import { IoClose, IoCheckmark } from "react-icons/io5";

const emailRegex = /^[^\s@]+@[^\s@]+$/;
const isoDateRegex = /(\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(.+?\d+)?)/;

const formatField = (value, extend = false, maxNmbOfChars = 20) => {
  if (value == null || value === "") {
    return "-";
  }
  switch (typeof value) {
    case "boolean":
      return formatBoolean(value);
    case "string":
      return formatString(value, extend, maxNmbOfChars);
    case "object":
      return formatObject(value);
    default:
      return value;
  }
};

const formatBoolean = (value) => {
  if (value) {
    return <IoCheckmark className="text-blue-600" />;
  }
  return <IoClose className="text-red-600" />;
};

const formatString = (value, extend, maxNmbOfChars) => {
  if (String(value).startsWith("http://") || String(value).startsWith("https://")) {
    return (
      <a
        href={value}
        className="text-blue-600 underline"
        target="_blank"
        rel="noreferrer"
      >
        link
      </a>
    );
  }
  let visibleValue = String(value);
  if (value.length >= maxNmbOfChars && !extend) {
    visibleValue = value.substring(0, maxNmbOfChars) + "...";
  }
  if (emailRegex.test(String(value).toLowerCase())) {
    return (
      <a href={"mailto:" + value} className="text-blue-600 underline">
        {visibleValue}
      </a>
    );
  }
  if (String(value).match(isoDateRegex)) {
    const date = new Date(value);
    return date.toLocaleString();
  }
  return visibleValue;
};

const formatObject = (value) => {
  console.log(value)
  if(Array.isArray(value))
  {
    return(
      value.map((url, idx) => (
        <div key={idx}>
          {formatString(url)}
        </div>
      ))
    )
  }

  Object.keys(value).map((key) => {
    return(
        <div key={key}>
          {formatString(value[key])}
        </div>
      );
    }
    )
  }

export default formatField;
